module.exports = __webpack_public_path__ + "static/media/16.0602e482.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/16.png
// module id = 1298
// module chunks = 0